import React from "react";

export default function List() {
  return (
    <div className="container mt-20">
      <div className="grid grid-cols-1 md:grid-cols-5">
        <div className="col-span-3 custom-bg-list"></div>

        <div className="bg-lime-600 col-span-2 flex justify-center items-center">
          <div className="text-white pl-5 pb-4">
            <h5 className="font-bold text-4xl mt-4">Ways of Protecting The Environment</h5>

            <hr className="w-56" />

            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi ex
              ducimus et, aperiam eveniet impedit.
            </p>

            <ol className="mt-5">
              <li>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                Nesciunt aliquid quasi, mollitia officiis dolorem nam voluptatum
                quas vero delectus velit nemo, aliquam error. Similique, unde?
              </li>
              <li>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem,
                quisquam dicta totam quas, saepe ea repudiandae ad nam iste
                adipisci obcaecati consectetur cumque! Repellendus, earum?
              </li>
              <li>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Magni
                illo repellat aut excepturi, neque, minus voluptas fugit natus
                at eius adipisci iure, ea fuga esse?
              </li>
            </ol>

            <button
              type="button"
              className="focus:outline-none text-white bg-lime-800 hover:bg-lime-500 focus:ring-4 focus:ring-green-300 font-medium rounded text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800 mt-7"
            >
              Read More About Us
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
